var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel',{attrs:{"perPage":1,"paginationEnabled":false}},[_c('slide',[_c('div',{staticClass:"padding"},[_c('img',{attrs:{"src":require("./anOrrery.jpg")}})])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }